import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-cream-dark py-14 md:py-20" data-id="element-240" data-mp="2lstjzhrrqcfl">
      <div className="max-w-4xl mx-auto px-6" data-id="element-241" data-mp="2lq8gkobtnofq">
        {/* First block — full width */}
        <motion.div className="space-y-6 text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} data-id="element-242" data-mp="30iinvkr8wujk">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark leading-tight" data-id="element-243" data-mp="3jer058ioe5od">
            La mayoría de las personas atraviesan momentos importantes de su
            vida sin un espacio para honrarlos.
          </h2>

          <div className="space-y-5 font-lora text-lg text-brown-light" data-id="element-244" data-mp="1k2xwwu5ao437">
            <p data-id="element-245" data-mp="1k4si89kh9y7t">
              Cuando terminamos relaciones… Cuando perdemos a alguien… Cuando
              empezamos una nueva etapa… Cuando necesitamos cerrar ciclos…
            </p>
            <p className="font-medium text-brown-dark" data-id="element-246" data-mp="ocpzmu40zlyn">
              No nos enseñaron a ritualizar la vida.
            </p>

            <div data-id="element-247" data-mp="sbp5cgxkzmr5">
              <p className="mb-2" data-id="element-248" data-mp="x4i9b2l86r26">Y por eso muchos momentos quedan:</p>
              <ul className="list-disc pl-5 space-y-1 text-brown-dark/80 inline-block text-left" data-id="element-249" data-mp="x6mk84hjkqby">
                <li data-id="element-250" data-mp="125pf4w3t5g67">inconclusos</li>
                <li data-id="element-251" data-mp="172fwrnv9gjtq">emocionalmente cargados</li>
                <li data-id="element-252" data-mp="1714qnhecezzg">energéticamente abiertos</li>
              </ul>
            </div>

            <div className="p-5 bg-cream-light border-l-4 border-gold-main rounded-r-sm" data-id="element-253" data-mp="1c33vkvpqe4yi">
              <p className="italic" data-id="element-254" data-mp="1g2cpc0kru2u2">
                El resultado: Personas cargando emociones que nunca pudieron
                integrar.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Second block — full width, stacked below */}
        <motion.div className="mt-12 space-y-5 text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-255" data-mp="p00lnsf9rr06">
          <div className="relative rounded-sm overflow-hidden shadow-xl" data-id="element-256" data-mp="17yldxnswd2fe">
            <img src="https://cdn.magicpatterns.com/uploads/dokEuDS7oLCkxGhccZmZiq/IMG_9018_1.webp" alt="Ceremonia al aire libre" className="w-full h-auto object-cover aspect-[16/9]" loading="lazy" data-id="element-257" data-mp="1301mj7vjayfn" />
            <div className="absolute inset-0 bg-gradient-to-t from-brown-dark/40 to-transparent" data-id="element-258" data-mp="1cqmu3kt6rdap"></div>
          </div>

          <div className="space-y-3" data-id="element-259" data-mp="1qn9r1nl523gm">
            <h3 className="text-2xl font-playfair font-semibold text-gold-dark" data-id="element-260" data-mp="1lrazjr4ik5bz">
              Aquí es donde los rituales conscientes cambian todo.
            </h3>
            <p className="font-lora text-brown-light" data-id="element-261" data-mp="2abebzilhcp5x">
              Un ritual no es solo un objeto, una vela o una ceremonia.
            </p>
            <p className="font-lora text-lg font-medium text-brown-dark" data-id="element-262" data-mp="1walgaujfzo18">
              Un ritual verdadero es un contenedor emocional y energético que te
              permite:
            </p>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 font-lora text-brown-light max-w-md mx-auto text-left" data-id="element-263" data-mp="1mlk31c4a7kqy">
              <li className="flex items-center gap-2" data-id="element-264" data-mp="1re4s60c8t9o5">
                <span className="text-gold-main" data-id="element-265" data-mp="1cnxf60508iuu">✦</span> integrar experiencias
              </li>
              <li className="flex items-center gap-2" data-id="element-266" data-mp="1hmh489ewaarf">
                <span className="text-gold-main" data-id="element-267" data-mp="1hn0b8v30beqo">✦</span> cerrar ciclos
              </li>
              <li className="flex items-center gap-2" data-id="element-268" data-mp="13nhfz2vanxvs">
                <span className="text-gold-main" data-id="element-269" data-mp="18mkb9vlh2pqk">✦</span> honrar momentos
              </li>
              <li className="flex items-center gap-2" data-id="element-270" data-mp="10l39xg8b02nx">
                <span className="text-gold-main" data-id="element-271" data-mp="10kl3jqrxg82a">✦</span> sanar heridas
              </li>
              <li className="flex items-center gap-2" data-id="element-272" data-mp="vmtct030qrzo">
                <span className="text-gold-main" data-id="element-273" data-mp="qvbcme8tkvfr">✦</span> abrir nuevas etapas
                con consciencia
              </li>
            </ul>
            <p className="font-lora font-medium text-brown-dark pt-3 border-t border-gold-main/20" data-id="element-274" data-mp="mtgc3bypqm31">
              Y eso es exactamente lo que aprenderás en este libro.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}